import { Col, Container, Row } from "react-bootstrap";

const LatpayFooter = () => {
    return ( 
        <footer className="Latpay-footer bg-dark text-light py-5 mt-5">
            <Container>
                <Row className="gy-4"> {/* gy-4 adds vertical spacing between columns on mobile */}
                    
                    {/* Column 1: Brand & Brief About */}
                    <Col lg={4} md={6} xs={12}>
                        <img 
                            src="/images/logosmall.png" 
                            className="App-logo mb-3" 
                            alt="Latpay Logo" 
                            height="60" 
                        />
                        <p className="text-secondary pe-lg-4 small lh-lg">
                            Empowering your business with seamless global payments, bank-level security, and developer-friendly integrations.
                        </p>
                    </Col>

                    {/* Column 2: Quick Links (Replaces the empty column) */}
                    <Col lg={2} md={6} xs={12}>
                        <h6 className="mb-3 text-uppercase fw-bold text-white-50">Company</h6>
                        <ul className="list-unstyled text-secondary small lh-lg">
                            <li><a href="#home" className="text-decoration-none text-secondary footer-link">Home</a></li>
                            <li><a href="#features" className="text-decoration-none text-secondary footer-link">Features</a></li>
                            <li><a href="#solutions" className="text-decoration-none text-secondary footer-link">Solutions</a></li>
                            <li><a href="#faq" className="text-decoration-none text-secondary footer-link">FAQ</a></li>
                        </ul>
                    </Col>

                    {/* Column 3: Australia Office */}
                    <Col lg={3} md={6} xs={12}>
                        <h6 className="mb-3 text-uppercase fw-bold text-white-50">Australia</h6>
                        <div className="text-secondary small lh-lg">
                            <div><strong>A:</strong> 222 Ferry Road, Southport</div>
                            <div>QLD 4215</div>
                            <div><strong>P:</strong> +61 7 5515 0402</div>
                            <div><strong>Toll Free:</strong> 1800 865 224</div>
                        </div>
                    </Col>

                    {/* Column 4: UK Office */}
                    <Col lg={3} md={6} xs={12}>
                        <h6 className="mb-3 text-uppercase fw-bold text-white-50">United Kingdom</h6>
                        <div className="text-secondary small lh-lg">
                            <div><strong>A:</strong> The Old Church, Quicks Road</div>
                            <div>London, SW19 1EX</div>
                            <div><strong>P:</strong> +44 (0) 208 5458840</div>
                            <div><strong>F:</strong> +44 (0) 208 5458839</div>
                        </div>
                    </Col>

                </Row>
            </Container>

            {/* Optional inline CSS for link hover effects */}
            <style type="text/css">
                {`
                .footer-link {
                    transition: color 0.3s ease;
                }
                .footer-link:hover {
                    color: #ffffff !important;
                }
                `}
            </style>
        </footer> 
    );
}
 
export default LatpayFooter;

// import { Col, Container, Row } from "react-bootstrap";

// const LatpayFooter = () => {
//     return ( 
//         <div className="Latpay-footer mt-5">
//             <Container>
//                 <Row className="p-5">
//                     <Col lg={3} md={6} xs={12}><img src="/images/logosmall.png" className="App-logo" alt="logo" />
//                     </Col>
//                     <Col lg={3} md={6} xs={12}></Col>
//                     <Col lg={3} md={6} xs={12}>
//                     <h4 className="mt-2">Australia</h4>
//                     <div>222 Ferry Road, Southport</div>
//                     <div>QLD 4215</div>
//                     <div>Phone: +61 7 5515 0402</div>
//                     <div>Toll Free: 1800 865 224</div>
//                     </Col>
//                     <Col lg={3} md={6} xs={12}>
//                     <h4 className="mt-2">United Kingdom</h4>
//                     <div>The Old Church, Quicks Road</div>
//                     <div>London, SW19 1EX</div>
//                     <div>Phone: +44 (0) 208 5458840</div>
//                     <div>Fax: +44 (0) 208 5458839</div>
//                     </Col>
//                 </Row>
//             </Container>
//         </div> 
//     );
// }
 
// export default LatpayFooter;